import { ReservationState, GlobalState } from '@/types/state'
import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import * as getterTypes from '@/store/getter-types'

import axios from '@/plugins/axios'
import Moment from 'moment'
import DailyReservation from '@/model/reservation/DailyReservation'
import DailyReservationHeader from '@/model/reservation/DailyReservationHeader'
import { USER_LOGGED_IN } from '@/store/getter-types'
import store from '@/store'
import {
  BatchReservationOptInPayload,
  BatchReservationOptOutPayload,
  OptInVerificationPayload,
  OptOutVerificationPayload
} from '@/types/payload'
import moment from 'moment'
import {OptInVerificationResponseItem, OptOutVerificationResponseItem} from '@/types/service-response'

const state: ReservationState = {
  loadingData: false,
  currentReservation: undefined,
  currentReservationHeader: undefined
}

const getters = {
  [getterTypes.LOADING_RESERVATION] (state: ReservationState): boolean {
    return state.loadingData
  },

  [getterTypes.CURRENT_RESERVATION] (state: ReservationState): DailyReservation | undefined {
    return state.currentReservation
  },

  [getterTypes.CURRENT_RESERVATION_HEADER] (state: ReservationState): DailyReservationHeader | undefined {
    return state.currentReservationHeader
  },
}

const mutations = {
  [mutationTypes.SET_LOADING_RESERVATION] (state: ReservationState, payload: boolean): void {
    state.loadingData = payload
  },

  [mutationTypes.SET_CURRENT_RESERVATION] (state: ReservationState, payload: DailyReservation): void {
    state.currentReservation = payload
  },

  [mutationTypes.SET_CURRENT_RESERVATION_HEADER] (state: ReservationState, payload: DailyReservationHeader): void {
    state.currentReservationHeader = payload
  },
}

const actions = {
  async [actionTypes.AVAILABLE_RESERVATION] ({ commit }: { commit: Function }, payload: any): Promise<void> {

    const user = store.getters[USER_LOGGED_IN]

    commit(mutationTypes.SET_LOADING_RESERVATION, true)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let res = await axios.get('/api/' + user.tenant.code + '/reporting/reservation-by-day?date=' + payload.date, { headers: headers })

    const data = DailyReservation.createFromResponse(res.data, payload.date)
    commit(mutationTypes.SET_CURRENT_RESERVATION, data)
    const header_data = DailyReservationHeader.createFromResponse(res.data)
    commit(mutationTypes.SET_CURRENT_RESERVATION_HEADER, header_data)

    commit(mutationTypes.SET_LOADING_RESERVATION, false)
  },

  async [actionTypes.FETCH_OPT_OUT_VERIFICATION] ({}, payload: OptOutVerificationPayload): Promise<OptOutVerificationResponseItem[]> {
    const user = store.getters[USER_LOGGED_IN]

    let headers = {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }

    const response = await axios.get(`/api/${user.tenant.code}/opt-out-verification`, {
      headers: headers,
      params: {
        'boarder-ids': payload.boarderIdList.join(';'),
        'dates': payload.dateList.map((d) => moment(d).format('YYYY-MM-DD')).join(';')
      }
    })

    return response.data
  },

  async [actionTypes.FETCH_OPT_IN_VERIFICATION] ({}, payload: OptInVerificationPayload): Promise<OptInVerificationResponseItem[]> {
    const user = store.getters[USER_LOGGED_IN]

    let headers = {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }

    const response = await axios.get(`/api/${user.tenant.code}/opt-in-verification`, {
      headers: headers,
      params: {
        'boarder-ids': payload.boarderIdList.join(';'),
        'dates': payload.dateList.map((d) => moment(d).format('YYYY-MM-DD')).join(';')
      }
    })

    return response.data
  },

  async [actionTypes.PERFORM_BATCH_RESERVATION_OPT_OUT] ({}, payload: BatchReservationOptOutPayload): Promise<void> {
    const user = store.getters[USER_LOGGED_IN]

    let headers = {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }

    const business = user.tenant.businessCollection[0]
    const topMenuGroup = business.menuGroupCollection.find((g: any) => g.isTopMenuGroup)

    await axios.post(`/api/${user.tenant.code}/batch-boarder-reservation-opt-out`, {
        business: business.id,
        topMenuGroup: topMenuGroup.id,
        'boarderList': payload.boarderIdList,
        'dateList': payload.dateList.map((d) => moment(d).format('YYYY-MM-DD'))
      },
      {
        headers: headers,
      })
  },

  async [actionTypes.PERFORM_BATCH_RESERVATION_OPT_IN] ({}, payload: BatchReservationOptInPayload): Promise<void> {
    const user = store.getters[USER_LOGGED_IN]

    let headers = {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }

    const business = user.tenant.businessCollection[0]
    const topMenuGroup = business.menuGroupCollection.find((g: any) => g.isTopMenuGroup)

    await axios.post(`/api/${user.tenant.code}/batch-boarder-reservation-opt-in`, {
        business: business.id,
        topMenuGroup: topMenuGroup.id,
        'boarderList': payload.boarderIdList,
        'dateList': payload.dateList.map((d) => moment(d).format('YYYY-MM-DD'))
      },
      {
        headers: headers,
      })
  }
}

const foodOrderingModule = {
  state,
  getters,
  mutations,
  actions
}

export default foodOrderingModule
